.painter {
  position: relative;
  flex: 1;
  overflow: hidden;
}
